var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":"myChart","width":"100%","height":"35%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }